import { authedFetch } from './http';

type Auth = { getToken: () => string | null; hydrate: () => Promise<void> };

/** Cross-user public persona — never exposes email/role/status. */
export type PublicProfile = {
  userId: string;
  nickname: string;
  avatarCap?: string;
  avatarUrl?: string;
  canton?: string;
};

/**
 * One row of another user's predictions. The server applies the tournament's
 * visibility policy: `hidden` rows have their pick cells zeroed out. `actualA/B`
 * are only present once the match is done. Mirrors `publicPredictionView`.
 */
export type PublicPrediction = {
  matchNumber: number;
  phase: string;
  matchStatus: 'upcoming' | 'live' | 'done' | 'cancelled';
  kickoffUtc: string;
  scoreA?: number;
  scoreB?: number;
  actualA?: number;
  actualB?: number;
  boost?: boolean;
  points?: number;
  hidden: boolean;
};

export type PublicPredictions = {
  userId: string;
  tournament: string;
  visibility: string;
  predictions: PublicPrediction[];
};

export function getPublicProfile(auth: Auth, userId: string): Promise<PublicProfile> {
  return authedFetch(auth.getToken, auth.hydrate, `/api/users/${userId}/profile`);
}

export function getPublicPredictions(auth: Auth, userId: string): Promise<PublicPredictions> {
  return authedFetch(auth.getToken, auth.hydrate, `/api/users/${userId}/predictions`);
}
